import CompetitionBasicModel from "../Competition/CompetitionBasicModel";
import PlayerBasicModel from "../Player/PlayerBasicModel";
import TeamBasicModel from "../Team/TeamBasicModel";

export default class SearchModel {
    public teams: TeamBasicModel[] = null;
    public players: PlayerBasicModel[] = null;
    public competitions: CompetitionBasicModel[] = null;
}
